"use client"

import { useRef, useState } from "react"
import SignatureCanvas from "react-signature-canvas"
import { Eraser } from "lucide-react"

import styles from "../css/driver.module.css"

/**
 * Proof-of-delivery signature capture.
 *
 * Reports the signature as a PNG data URL through `onChange`, plus who signed
 * for it, so the parent can send both with the completion.
 */
export default function SignaturePad({ receivedBy, onReceivedByChange, onChange, disabled }) {
  const padRef = useRef(null)
  const [hasInk, setHasInk] = useState(false)

  const handleEnd = () => {
    const pad = padRef.current
    if (!pad) return

    const empty = pad.isEmpty()
    setHasInk(!empty)
    onChange(empty ? null : pad.toDataURL("image/png"))
  }

  const handleClear = () => {
    padRef.current?.clear()
    setHasInk(false)
    onChange(null)
  }

  return (
    <div className={styles.field}>
      <div className={styles.field}>
        <label className={styles.fieldLabel} htmlFor="received-by">
          Received by
        </label>
        <input
          id="received-by"
          className={styles.input}
          placeholder="Name of person signing"
          autoComplete="off"
          value={receivedBy}
          disabled={disabled}
          onChange={(e) => onReceivedByChange(e.target.value)}
        />
      </div>

      <span className={styles.fieldLabel} id="signature-label">
        Signature
      </span>

      <div className={styles.signatureFrame} aria-labelledby="signature-label">
        <SignatureCanvas
          ref={padRef}
          penColor="#16202c"
          onEnd={handleEnd}
          canvasProps={{ className: styles.signatureCanvas }}
        />
        {!hasInk && (
          <div className={styles.signatureHint} aria-hidden="true">
            Sign here
          </div>
        )}
      </div>

      <button
        type="button"
        className={styles.ghostBtn}
        onClick={handleClear}
        disabled={disabled || !hasInk}
      >
        <Eraser size={16} aria-hidden="true" />
        Clear signature
      </button>
    </div>
  )
}
